<template>
  <div class="flex-col gap-lg">
    <dd-card>
      <div class="flex-col gap-md" v-if="!loading">
        <dd-customer-select
            name="customer_id"
            title="Klant kiezen"
            v-model="form.customer_id"
            data-dusk="task-customer"
            searchable
        ></dd-customer-select>

        <div v-if="taskListTemplates">
          <dd-select
              title="Takenreeks template"
              label="Kies een takenreeks template"
              :options="getTaskListTemplates"
              v-model="taskListTemplateId"
              class="flex-stretch"
          ></dd-select>
        </div>

        <div v-if="getTaskListTemplate">
          <h3>
            Beschrijving
          </h3>
          <p>
            {{ getTaskListTemplate.description || "Niet bekend" }}
          </p>
        </div>
      </div>
    </dd-card>
    <dd-card
        v-if="taskListTemplateId"
        v-for="(taskListTaskTemplate, index) in getTaskListTaskTemplates"
        :key="index"
    >
      <div class="flex-row justify-content-between">
        <h3>
          {{ taskListTaskTemplate.name }}
        </h3>
        <p>
          Taak {{ index + 1}}
        </p>
      </div>
      <p>
        {{ taskListTaskTemplate.description || 'Niet bekend' }}
      </p>
      <dd-form-grid>
        <dd-form-grid-item>
          <dd-input-wrapper
              title="Datum"
          ></dd-input-wrapper>
          <a-radio-group
              v-model="form.task_list_items_overrides[index].date"
              button-style="solid"
          >
            <a-radio-button :value="0">Zelfde dag</a-radio-button>
            <a-radio-button :value="1">Dag erna</a-radio-button>
            <a-radio-button :value="7">1 week erna</a-radio-button>
            <a-radio-button :value="14">2 weken erna</a-radio-button>
            <a-radio-button :value="21">3 weken erna</a-radio-button>
            <a-radio-button :value="30">1 maand erna</a-radio-button>
            <a-radio-button :value="365">1 jaar erna</a-radio-button>
            <a-radio-button :value="1095"
            >3 jaar erna
            </a-radio-button>
            <a-radio-button :value="1825"
            >5 jaar erna
            </a-radio-button>
          </a-radio-group>
        </dd-form-grid-item>
        <dd-form-grid-item>
          <dd-input-wrapper title="Gebruiker(s)">
            <users-select
                class="task-input-users mt4"
                :disabled="loading"
                v-model="
                      form.task_list_items_overrides[index].assigned_users
                    "
            />
          </dd-input-wrapper>
        </dd-form-grid-item>
        <dd-form-grid-item>
          <dd-input-wrapper title="Afdeling(en)">
            <user-departments-select
                v-model="
                      form.task_list_items_overrides[index].assigned_departments
                    "
            />
          </dd-input-wrapper>
        </dd-form-grid-item>
        <dd-form-grid-item>
          <dd-input-wrapper title="Product label(s)">
            <product-labels-select
                product-category="task"
                v-model="
                      form.task_list_items_overrides[index].assigned_product_labels
                    "
            />
          </dd-input-wrapper>
        </dd-form-grid-item>
      </dd-form-grid>
    </dd-card>
    <div>
      <dd-button
          @click="saveTaskList"
          :loading="loadingSubmit"
          :disabled="!form.customer_id || !taskListTemplateId"
      >
        Starten
      </dd-button>
    </div>
  </div>
</template>

<script>
import taskTemplateApi from "~/api/task_template";
import taskListApi from "~/api/task_list";
import taskListTemplateApi from "~/api/task_list_template";
import CreateOrEditTaskComponent from "~/modules/task/components/CreateOrEditTaskComponent.vue";

export default {
  props: {
    customerId: Number | null,
  },
  data() {
    return {
      availableTaskTemplates: null,
      taskListTemplates: null,
      loading: false,
      loadingSubmit: false,
      taskListTemplateId: null,
      form: {
        customer_id: this.customerId,
        task_list_items_overrides: [],
      },
    };
  },
  components: {
    CreateOrEditTaskComponent,
  },
  async mounted() {
    this.loading = true;

    try {
      this.fetchTaskTemplates();

      if (this.taskListTemplateId) {
        this.fetchTaskListTemplate();
      } else if (this.taskListId) {
        console.error("Not implemented yet");
      } else {
        this.fetchTaskListTemplates();
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async fetchTaskTemplates() {
      let response = await taskTemplateApi.get([
        "users",
        "departments",
        "product_labels",
      ]);

      this.availableTaskTemplates = response.data;
    },
    async fetchTaskListTemplate() {
      let response = await taskListTemplateApi.get(this.taskListTemplateId);

      this.taskListTemplate = response.taskListTemplate;
    },
    async fetchTaskListTemplates() {
      let response = await taskListTemplateApi.all();

      this.taskListTemplates = response.taskListTemplates;
    },
    async saveTaskList() {
      this.loadingSubmit = true;
      try {
        let response = await taskListApi.save(
            this.taskListTemplateId,
            this.form
        );

        window.location.href = response.location;
      } catch (e) {
        console.error(e);
      } finally {
        this.loadingSubmit = false;
      }
    },
  },
  computed: {
    getTaskListTemplate() {
      if (!this.taskListTemplateId) {
        return null;
      }

      return (
          this.taskListTemplates.find(
              (taskListTemplate) => taskListTemplate.id == this.taskListTemplateId
          ) || null
      );
    },
    getTaskListTaskTemplates() {
      if (!this.getTaskListTemplate || !this.availableTaskTemplates) {
        return [];
      }

      return this.getTaskListTemplate.task_list_item_templates.map(
          (taskListItemTemplate) => {
            return this.availableTaskTemplates.find(
                (template) => template.id === taskListItemTemplate.task_template_id
            );
          }
      );
    },
    getTaskListTemplates() {
      return this.taskListTemplates.map((taskListTemplate) => {
        return {
          value: taskListTemplate.id,
          label: taskListTemplate.name,
        };
      });
    },
  },
  watch: {
    taskListTemplateId() {
      this.form.task_list_items_overrides = this.getTaskListTaskTemplates.map(
          (template) => {
            return {
              assigned_users: template.users.data?.map((user) => user.id),
              assigned_departments: template.departments.data?.map(
                  (department) => department.id
              ),
              assigned_product_labels: template.product_labels.data?.map(
                  (label) => label.id
              ),
              date: template.date,
            };
          }
      );
    },
  },
};
</script>

<style scoped></style>
